import { Alert, AlertDescription } from "@screener/uikit/components/alert";
import { Button } from "@screener/uikit/components/button";

/**
 * Полоса отказа §6.6/§6.7 над списком — узкий `Alert` во всю ширину экрана
 * с кнопкой «Скрыть», без своих полей содержимого (ревью
 * stage6-acceptance-debts, второй круг, пункт 4): закрепление и избранное
 * несли по копии этой полосы в `density-screen.tsx`, различающейся только
 * текстом и обработчиком закрытия. Место — экран, не `@screener/uikit`:
 * форма («во всю ширину, без скруглений, `text-xs`») и повод («Скрыть»
 * гасит именно это уведомление) принадлежат `DensityScreen`, а не UIKit,
 * который не знает ни о закреплениях, ни об избранном.
 */
export function DismissibleErrorBanner({
  text,
  onDismiss,
}: {
  text: string;
  onDismiss: () => void;
}) {
  return (
    <Alert
      variant="error"
      className="items-center rounded-none border-x-0 border-t-0 px-3 py-1.5 text-xs"
    >
      <AlertDescription className="text-xs">{text}</AlertDescription>
      <Button
        variant="ghost"
        size="sm"
        className="ml-auto h-5 px-1.5 text-[11px]"
        onClick={onDismiss}
      >
        Скрыть
      </Button>
    </Alert>
  );
}
